<template>
    <div class="app" style="height: 100%;">

    </div>
  </template>
  <script>
  
  //import srcLogo from "@/assets/images/kaidelogo.png";
  
  export default {
    // name: "workOrderSource",
    components: {
      
    },
    props: {
      
    },
    data() {
      return {
  
      };
    },
    created() {
      
    },
    computed: {
    },
    methods: {
  
    },
  };
  </script>
  <style scoped>
  
  </style>
  